export default "__VITE_ASSET__yywFRspN__"